module.exports = __webpack_public_path__ + "img/summary-2.b37990c1.svg";